import React from "react";
import { Link } from 'react-router-dom';
import './SculcNavbar.css';

const SculcNavbar = () => {
    return (
        <nav className="nav">
            <Link to="/" className="sitename">
                <img src="/images/sculc-logo.png" alt="SCULC logo" className="logo-image" />
            </Link>
            <div className="links">
                <Link to="/sculc-2027" className="sculc">Home</Link>
                <Link to="/sculc-2022-program" className="sculc">Programs</Link>
                <Link to="/sculc-2022-presentation" className="sculc">Presentations</Link>
                <Link to="/sculc-2022-photo" className="sculc">Photos</Link>
            </div>
        </nav>
    );
};

export default SculcNavbar;